import React, { useRef } from "react"
import { LocomotiveScrollProvider } from "react-locomotive-scroll"
import { useLocation } from "react-router-dom"
import { Outlet } from "react-router-dom"

const Locomotive = () => {
  const location = useLocation()
  const containerRef = useRef(null)
  return (
    <LocomotiveScrollProvider
      options={{
        smooth: true,
      }}
      watch={[]}
      containerRef={containerRef}
      location={location.pathname}
    >
      <div data-scroll-container ref={containerRef}>
        <Outlet />
      </div>
    </LocomotiveScrollProvider>
  )
}

export default Locomotive
